<template>
    <div class="page-container">
        <!-- 查询区 -->
        <el-card class="box-card search-card" shadow="never">
            <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                <el-form-item label="企业名称">
                    <el-input clearable v-model="queryParams.companyName" placeholder="请输入企业名称"
                              prefix-icon="el-icon-office-building"></el-input>
                </el-form-item>
                <el-form-item label="租户状态">
                    <el-select clearable v-model="queryParams.status" placeholder="请选择租户状态">
                        <el-option label="正常" value="0"></el-option>
                        <el-option label="禁用" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="btnSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="btnReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <div style="height: 12px;"></div>

        <!-- 表格区 -->
        <el-card class="box-card" shadow="never">
            <div class="table-toolbar">
                <div class="toolbar-title">
                    <i class="el-icon-s-grid"></i> 租户列表
                </div>
                <div class="toolbar-actions">
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd(null)">新增租户</el-button>
                    <el-button icon="el-icon-circle-check" size="small" @click="handleCheckData">数据校验</el-button>
                    <el-button icon="el-icon-refresh" size="small" @click="syncTenantDict">同步租户字典</el-button>
                </div>
            </div>

            <el-table :data="tableData" border stripe style="width: 100%" v-loading="loading"
                      header-row-class-name="table-header">
                <el-table-column type="index" label="#" width="60" align="center"></el-table-column>
                <el-table-column prop="tenantId" label="租户编号" width="110"></el-table-column>
                <el-table-column prop="companyName" label="企业名称" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="contactUserName" label="联系人" width="110"></el-table-column>
                <el-table-column prop="contactPhone" label="联系电话" width="140"></el-table-column>
                <el-table-column prop="packageName" label="所属套餐" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="租户状态" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === '0' ? 'success' : 'info'" size="medium">
                            {{ scope.row.status === '0' ? '正常' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
                <el-table-column align="center" label="操作" width="220" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="handleAdd(scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-upload2" @click="handleSyncData(scope.row)">同步数据</el-button>
                        <el-button type="text" icon="el-icon-delete" class="text-danger" @click="handleDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination style="margin-top:14px;"
                           background
                           layout="total, prev, pager, next"
                           @current-change="currentChange"
                           :total="total">
            </el-pagination>
        </el-card>

        <!-- 新增/编辑弹窗 -->
        <el-dialog :title="form.id ? '修改租户' : '新增租户'"
                   :visible.sync="dialogVisible"
                   width="560px"
                   @close="closeDialog"
                   :close-on-click-modal="false">
            <el-form :model="form" ref="form" label-width="100px" :rules="rules">
                <el-form-item label="企业名称" prop="companyName">
                    <el-input v-model="form.companyName" placeholder="请输入企业名称"
                              prefix-icon="el-icon-office-building" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="contactUserName">
                    <el-input v-model="form.contactUserName" placeholder="请输入联系人姓名"
                              prefix-icon="el-icon-user" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="contactPhone">
                    <el-input v-model="form.contactPhone" placeholder="请输入11位手机号"
                              prefix-icon="el-icon-phone"
                              maxlength="11" show-word-limit
                              oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="选择套餐" prop="packageId">
                    <el-select v-model="form.packageId" placeholder="请选择租户套餐" style="width:100%;"
                               filterable>
                        <el-option v-for="item in tenantPackageList" :key="item.id"
                                   :label="item.packageName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="过期时间" prop="expireTime">
                    <el-date-picker v-model="form.expireTime" type="datetime"
                                    placeholder="选择套餐过期时间" style="width:100%;"
                                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="form.remark" type="textarea" :rows="3"
                              maxlength="200" show-word-limit placeholder="请输入备注信息"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="btnSubmit('form')">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 同步教学基础数据弹窗 -->
        <el-dialog :title="'同步教学基础数据 → ' + (syncForm.targetCompanyName || '')"
                   :visible.sync="syncDialogVisible"
                   width="580px"
                   @close="closeSyncDialog"
                   :close-on-click-modal="false">
            <el-form :model="syncForm" ref="syncForm" label-width="100px" :rules="syncRules">
                <el-form-item label="源租户" prop="sourceTenantId">
                    <el-select v-model="syncForm.sourceTenantId" placeholder="请选择源租户" style="width:100%;"
                               filterable :disabled="syncRunning">
                        <el-option v-for="item in tableData" :key="item.tenantId"
                                   :label="item.companyName + '（' + item.tenantId + '）'"
                                   :value="item.tenantId"
                                   :disabled="item.tenantId === syncForm.targetTenantId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="同步内容">
                    <el-checkbox-group v-model="syncForm.contents" :disabled="syncRunning">
                        <el-checkbox label="grade">年级</el-checkbox>
                        <el-checkbox label="unit">单元</el-checkbox>
                        <el-checkbox label="word">单词</el-checkbox>
                        <el-checkbox label="wordExtension">单词拓展</el-checkbox>
                        <el-checkbox label="essayType">作文类型</el-checkbox>
                        <el-checkbox label="essayQuestion">作文题库</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-alert type="warning" :closable="false" show-icon style="margin-bottom:12px;">
                    <div slot="title" style="line-height:1.6;">
                        同步按「年级级别+学段」「单元名+分册」匹配；同一键已存在则<b>覆盖更新</b>，不会重复新增。
                        <br/>⚠ 会覆盖目标租户中同名年级/单元/单词的数据。同步后会自动清除资源树缓存。
                    </div>
                </el-alert>
                <!-- 进度与结果 -->
                <div v-if="syncRunning || syncResult">
                    <el-divider content-position="left">同步进度</el-divider>
                    <div v-if="syncRunning" style="margin-bottom:8px;">
                        <span style="color:#606266;">{{ syncResult.stage || '处理中' }}</span>
                        <span v-if="syncResult.stageTotal" style="color:#909399;margin-left:8px;">
                            {{ syncResult.stageCurrent || 0 }} / {{ syncResult.stageTotal }}
                        </span>
                    </div>
                    <el-progress v-if="syncRunning"
                                 :percentage="syncPercent"
                                 :status="syncPercent >= 100 ? 'success' : ''"></el-progress>
                    <div v-if="!syncRunning && syncResult" class="sync-result">
                        <div v-if="syncResult.status === 'SUCCESS'">
                            <p><b>同步完成</b>（耗时 {{ ((syncResult.costMs || 0) / 1000).toFixed(1) }} 秒）</p>
                            <p>年级：新增 {{ syncResult.gradeInsert }} / 覆盖 {{ syncResult.gradeUpdate }}</p>
                            <p>单元：新增 {{ syncResult.unitInsert }} / 覆盖 {{ syncResult.unitUpdate }}</p>
                            <p>单词：新增 {{ syncResult.wordInsert }} / 覆盖 {{ syncResult.wordUpdate }}</p>
                            <p>单词拓展：新增 {{ syncResult.wordExtInsert }} / 覆盖 {{ syncResult.wordExtUpdate }}</p>
                            <p>作文类型：新增 {{ syncResult.essayTypeInsert }} / 覆盖 {{ syncResult.essayTypeUpdate }}</p>
                            <p>作文题库：新增 {{ syncResult.essayQuestionInsert }} / 覆盖 {{ syncResult.essayQuestionUpdate }}</p>
                            <p v-if="syncResult.skipCount">跳过：{{ syncResult.skipCount }} 条</p>
                        </div>
                        <el-alert v-else-if="syncResult.status === 'FAILED'" type="error" :closable="false" show-icon
                                  :title="'同步失败：' + (syncResult.errorMsg || '未知错误')"></el-alert>
                        <div v-if="syncResult.failDetails && syncResult.failDetails.length" style="margin-top:8px;">
                            <el-collapse>
                                <el-collapse-item :title="'跳过/失败明细（' + syncResult.failDetails.length + ' 条）'">
                                    <div v-for="(d, i) in syncResult.failDetails" :key="i"
                                         style="font-size:12px;color:#909399;line-height:1.8;">{{ d }}</div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeSyncDialog" :disabled="syncRunning">关 闭</el-button>
                <el-button type="primary" :loading="syncRunning" :disabled="syncRunning"
                           @click="submitSync('syncForm')">
                    {{ syncRunning ? '同步中…' : '开始同步' }}
                </el-button>
            </span>
        </el-dialog>

        <!-- 数据一致性校验弹窗 -->
        <el-dialog title="教学数据一致性校验" :visible.sync="checkDialogVisible" width="880px"
                   @close="closeCheckDialog" :close-on-click-modal="false">
            <el-form :inline="true" :model="checkForm" size="small">
                <el-form-item label="源租户">
                    <el-select v-model="checkForm.sourceTenantId" placeholder="请选择" filterable style="width:220px;">
                        <el-option v-for="item in tableData" :key="item.tenantId"
                                   :label="item.companyName + '（' + item.tenantId + '）'"
                                   :value="item.tenantId"
                                   :disabled="item.tenantId === checkForm.targetTenantId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目标租户">
                    <el-select v-model="checkForm.targetTenantId" placeholder="请选择" filterable style="width:220px;">
                        <el-option v-for="item in tableData" :key="item.tenantId"
                                   :label="item.companyName + '（' + item.tenantId + '）'"
                                   :value="item.tenantId"
                                   :disabled="item.tenantId === checkForm.sourceTenantId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" :loading="checkLoading"
                               @click="submitCheck">开始校验</el-button>
                </el-form-item>
            </el-form>

            <el-alert type="info" :closable="false" show-icon style="margin-bottom:12px;"
                      title="校验说明：以同步所用的幂等键口径逐表比对（年级按级别+学段、单元按年级+分册+单元名、单词按单元+单词名）。「缺失」= 源有目标无；「差异」= 同键但关键字段内容不同；「多余」= 目标多出的数据（可能是目标租户自行录入，仅供参考）。">
            </el-alert>

            <div v-if="checkResult">
                <div style="margin-bottom:10px;">
                    <el-tag v-if="checkResult.passed" type="success" effect="dark">校验通过：数据一致</el-tag>
                    <el-tag v-else type="danger" effect="dark">校验未通过：存在缺失或差异</el-tag>
                </div>
                <el-table :data="checkResult.items" border size="small" :row-class-name="checkRowClass">
                    <el-table-column prop="tableLabel" label="数据表" width="100" align="center"></el-table-column>
                    <el-table-column prop="tableName" label="表名" width="150"></el-table-column>
                    <el-table-column prop="sourceCount" label="源条数" width="80" align="center"></el-table-column>
                    <el-table-column prop="targetCount" label="目标条数" width="90" align="center"></el-table-column>
                    <el-table-column prop="matchedCount" label="一致" width="70" align="center"></el-table-column>
                    <el-table-column label="缺失" width="70" align="center">
                        <template slot-scope="scope">
                            <span :class="{ 'check-bad': scope.row.missingCount > 0 }">{{ scope.row.missingCount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="差异" width="70" align="center">
                        <template slot-scope="scope">
                            <span :class="{ 'check-bad': scope.row.diffCount > 0 }">{{ scope.row.diffCount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="extraCount" label="多余" width="70" align="center"></el-table-column>
                    <el-table-column label="结论" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.passed ? 'success' : 'danger'" size="mini">
                                {{ scope.row.passed ? '通过' : '不通过' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="明细" min-width="120" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.details && scope.row.details.length" type="text"
                                       @click="showCheckDetail(scope.row)">查看({{ scope.row.details.length }})</el-button>
                            <span v-else style="color:#909399;">—</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeCheckDialog">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 差异明细弹窗 -->
        <el-dialog :title="checkDetailTitle" :visible.sync="checkDetailVisible" width="620px" append-to-body>
            <div style="max-height:420px;overflow:auto;">
                <p v-for="(d, i) in checkDetailList" :key="i"
                   style="font-size:13px;color:#606266;line-height:1.9;margin:0;">{{ i + 1 }}. {{ d }}</p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    reqDeleteSysTenant,
    reqInsertSysTenant,
    reqListSysTenant,
    reqUpdateSysTenant,
    reqSyncTenantData,
    reqSyncTenantResult,
    reqCheckTenantData
} from "@/api/system/tenant";
import {reqListAllSysTenantPackage, reqListSysTenantPackage} from "@/api/system/tenant_package";

export default {
    name: 'tenant',
    async created() {
        await this.load();
        await this.loadTenantPackage();
    },
    beforeDestroy() {
        this.stopPolling();
    },
    computed: {
        // 同步进度百分比（按当前阶段 已处理/总量 估算）
        syncPercent() {
            const r = this.syncResult;
            if (!r || !r.stageTotal) {
                return r && r.status === 'SUCCESS' ? 100 : 0;
            }
            const p = Math.floor((r.stageCurrent || 0) * 100 / r.stageTotal);
            return Math.min(p, 99);
        }
    },
    methods: {
        // 获取表格数据
        async load() {
            this.loading = true;
            this.tableData = [];
            let data = await reqListSysTenant(this.queryParams);
            this.tableData = data.records || [];
            this.total = data.total || 0;
            this.loading = false;
        },
        async loadTenantPackage() {
            let data = await reqListAllSysTenantPackage({});
            this.tenantPackageList = data || [];
        },
        // 点击查询按钮
        async btnSearch() {
            this.queryParams.currentPage = 1;
            await this.load();
        },
        // 点击重置按钮
        async btnReset() {
            this.queryParams = {currentPage: 1, pageSize: 10};
            await this.load();
        },
        currentChange(num) {
            this.queryParams.currentPage = num;
            this.load();
        },
        handleAdd(item) {
            if (item) {
                this.form = JSON.parse(JSON.stringify(item));
            } else {
                this.form = {status: '0'};
            }
            this.dialogVisible = true;
        },
        closeDialog() {
            this.dialogVisible = false;
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        },
        syncTenantDict() {
            this.$message.info('租户字典已是最新');
        },
        async btnSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if (this.form.id) {
                        await reqUpdateSysTenant(this.form);
                    } else {
                        await reqInsertSysTenant(this.form);
                    }
                    this.$message.success("操作成功");
                    this.closeDialog();
                    await this.load();
                }
            });
        },

        // ==================== 同步教学基础数据 ====================
        handleSyncData(row) {
            this.syncForm = {
                sourceTenantId: '',
                targetTenantId: row.tenantId,
                targetCompanyName: row.companyName,
                contents: ['grade', 'unit', 'word', 'wordExtension', 'essayType', 'essayQuestion']
            };
            this.syncResult = null;
            this.syncRunning = false;
            this.syncTaskId = '';
            this.syncDialogVisible = true;
        },
        closeSyncDialog() {
            if (this.syncRunning) {
                this.$message.warning('同步进行中，请等待完成后再关闭');
                return;
            }
            this.syncDialogVisible = false;
            if (this.$refs.syncForm) {
                this.$refs.syncForm.clearValidate();
            }
        },
        submitSync(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (!valid) return;
                if (!this.syncForm.contents.length) {
                    this.$message.warning('请至少选择一项同步内容');
                    return;
                }
                const c = this.syncForm.contents;
                const payload = {
                    sourceTenantId: this.syncForm.sourceTenantId,
                    targetTenantId: this.syncForm.targetTenantId,
                    syncGrade: c.includes('grade'),
                    syncUnit: c.includes('unit'),
                    syncWord: c.includes('word'),
                    syncWordExtension: c.includes('wordExtension'),
                    syncEssayType: c.includes('essayType'),
                    syncEssayQuestion: c.includes('essayQuestion')
                };
                try {
                    const taskId = await reqSyncTenantData(payload);
                    if (!taskId) {
                        this.$message.error('提交同步任务失败');
                        return;
                    }
                    this.syncTaskId = taskId;
                    this.syncRunning = true;
                    this.syncResult = {status: 'RUNNING', stage: '排队中', stageCurrent: 0, stageTotal: 0};
                    this.startPolling();
                } catch (e) {
                    this.$message.error(e.message || '提交同步任务失败');
                }
            });
        },
        startPolling() {
            this.stopPolling();
            this.pollTimer = setInterval(async () => {
                try {
                    const res = await reqSyncTenantResult({taskId: this.syncTaskId});
                    if (!res) return;
                    this.syncResult = res;
                    if (res.status === 'SUCCESS' || res.status === 'FAILED') {
                        this.stopPolling();
                        this.syncRunning = false;
                        if (res.status === 'SUCCESS') {
                            this.$message.success('同步完成');
                        } else {
                            this.$message.error('同步失败：' + (res.errorMsg || '未知错误'));
                        }
                    }
                } catch (e) {
                    this.stopPolling();
                    this.syncRunning = false;
                    this.$message.error('查询同步进度失败：' + (e.message || ''));
                }
            }, 1500);
        },
        stopPolling() {
            if (this.pollTimer) {
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }
        },

        // ==================== 数据一致性校验 ====================
        handleCheckData() {
            this.checkForm = {sourceTenantId: '', targetTenantId: ''};
            this.checkResult = null;
            this.checkDialogVisible = true;
        },
        closeCheckDialog() {
            this.checkDialogVisible = false;
        },
        async submitCheck() {
            if (!this.checkForm.sourceTenantId || !this.checkForm.targetTenantId) {
                this.$message.warning('请选择源租户与目标租户');
                return;
            }
            if (this.checkForm.sourceTenantId === this.checkForm.targetTenantId) {
                this.$message.warning('源租户与目标租户不能相同');
                return;
            }
            this.checkLoading = true;
            try {
                const res = await reqCheckTenantData({
                    sourceTenantId: this.checkForm.sourceTenantId,
                    targetTenantId: this.checkForm.targetTenantId
                });
                this.checkResult = res;
                if (res && res.passed) {
                    this.$message.success('校验通过：数据一致');
                } else if (res) {
                    this.$message.warning('校验完成：存在缺失或差异，请查看明细');
                }
            } catch (e) {
                this.$message.error(e.message || '校验失败');
            } finally {
                this.checkLoading = false;
            }
        },
        checkRowClass({row}) {
            return row.passed ? '' : 'check-row-fail';
        },
        showCheckDetail(row) {
            this.checkDetailTitle = row.tableLabel + '（' + row.tableName + '）差异明细';
            this.checkDetailList = row.details || [];
            this.checkDetailVisible = true;
        },

        handleDelete(id) {
            this.$confirm("此操作将永久删除该租户及其关联数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                await reqDeleteSysTenant({id: id});
                this.$message.success("操作成功");
                await this.load();
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
    },
    data() {
        // 手机号校验：11位且以1开头
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入联系电话'));
            } else if (!/^1\d{10}$/.test(value)) {
                callback(new Error('请输入有效的11位手机号'));
            } else {
                callback();
            }
        };
        return {
            queryParams: {
                currentPage: 1,
                pageSize: 10,
            },
            tableData: [],
            total: 0,
            loading: false,
            dialogVisible: false,
            form: {},
            tenantPackageList: [],
            // ---- 同步教学基础数据 ----
            syncDialogVisible: false,
            syncForm: {
                sourceTenantId: '',
                targetTenantId: '',
                targetCompanyName: '',
                contents: []
            },
            syncResult: null,
            syncRunning: false,
            syncTaskId: '',
            pollTimer: null,
            // ---- 数据一致性校验 ----
            checkDialogVisible: false,
            checkForm: {
                sourceTenantId: '',
                targetTenantId: ''
            },
            checkLoading: false,
            checkResult: null,
            checkDetailVisible: false,
            checkDetailTitle: '',
            checkDetailList: [],
            syncRules: {
                sourceTenantId: [
                    {required: true, message: '请选择源租户', trigger: 'change'}
                ],
            },
            rules: {
                companyName: [
                    {required: true, message: '请输入企业名称', trigger: 'blur'},
                    {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'}
                ],
                contactUserName: [
                    {required: true, message: '请输入联系人', trigger: 'blur'},
                ],
                contactPhone: [
                    {required: true, validator: validatePhone, trigger: 'blur'},
                ],
                packageId: [
                    {required: true, message: '请选择租户套餐', trigger: 'change'},
                ],
            },
        }
    },
}
</script>

<style scoped>
.page-container {
    padding: 16px;
}

.search-card {
    border-radius: 8px;
}

.box-card {
    border-radius: 8px;
}

.table-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.toolbar-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    display: flex;
    align-items: center;
}

.toolbar-title i {
    margin-right: 6px;
    color: #409EFF;
}

.table-header th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.text-danger {
    color: #F56C6C;
}

.text-danger:hover {
    color: #f78989;
}

.sync-result {
    font-size: 13px;
    color: #606266;
    line-height: 1.9;
}

.sync-result p {
    margin: 0;
}

.check-bad {
    color: #F56C6C;
    font-weight: bold;
}

::v-deep .check-row-fail {
    background-color: #fef0f0;
}
</style>
